import { Color } from '@kite-js/theme-types';

const orange: Color = {
    50: '#feead3',
    100: '#fbc17a',
    200: '#faac4d',
    300: '#f99721',
    400: '#e07a00',
    500: '#c16900',
};

export default orange;
